import gql from 'graphql-tag';

const CREATE_POLICY_CATEGORIES = gql`
  mutation($name: String!, $classId: ID!) {
    createPolicyCategory(name: $name, classId: $classId) {
      policyCategoryId
      name
    }
  }
`;

const UPDATE_POLICY_CATEGORIES = gql`
  mutation($policyCategoryId: ID!, $name: String!) {
    updatePolicyCategory(policyCategoryId: $policyCategoryId, name: $name) {
      policyCategoryId
      name
    }
  }
`;
const DELETE_POLICY_CATEGORIES = gql`
  mutation($policyCategoryId: ID!) {
    deletePolicyCategory(policyCategoryId: $policyCategoryId)
  }
`;

const ASSIGN_POLICY_CATEGORY = gql`
  mutation(
    $entityIds: [ID!]
    $policyCategoryId: ID!
    $ignoreUnMappedEntity: Boolean
  ) {
    assignPolicyCategory(
      entityIds: $entityIds
      policyCategoryId: $policyCategoryId
      ignoreUnMappedEntity: $ignoreUnMappedEntity
    )
  }
`;

const ASSIGN_POLICY_CATEGORY_V2 = gql`
  mutation($input: AssignPolicyCategoryInput!) {
    assignPolicyCategoryV2(input: $input)
  }
`;

const ASSOCIATE_POLICYSET_MAPPING = gql`
  mutation($input: AssociatePolicyCategoryInput) {
    associatePolicySetMappings(input: $input)
  }
`;

const CREATE_POLICY_SET = gql`
  mutation($name: String!, $parentPolicySetId: ID!) {
    createPolicySet(name: $name, parentPolicySetId: $parentPolicySetId) {
      policySetId
      name
      category
      parentPolicySet {
        policySetId
        name
      }
      lastUpdatedTime
      lastUpdatedBy {
        userId
        name
      }
    }
  }
`;
const UPDATE_CLIENT_POLICY_MIGRATION = gql`
  mutation($clientId: ID, $enabled: Boolean) {
    updateClientPolicyMigrationStatus(clientId: $clientId, enabled: $enabled)
  }
`;

const UPDATE_ADV_HIERARCHY_MIGRATION = gql`
  mutation($status: String) {
    updateAdvancedHierarchyMigrationStatus(status: $status)
  }
`;

export {
  CREATE_POLICY_CATEGORIES,
  UPDATE_POLICY_CATEGORIES,
  DELETE_POLICY_CATEGORIES,
  ASSIGN_POLICY_CATEGORY,
  ASSIGN_POLICY_CATEGORY_V2,
  CREATE_POLICY_SET,
  UPDATE_CLIENT_POLICY_MIGRATION,
  UPDATE_ADV_HIERARCHY_MIGRATION,
  ASSOCIATE_POLICYSET_MAPPING
};
